<script setup lang="ts">
defineProps<{
	title: string;
	description: string;
}>();
</script>

<template>
	<div class="flex flex-col gap-1">
		<h3
			class="flex items-center gap-3 font-matter-sq text-[28px] font-normal text-white md:text-[32px]"
		>
			<span class="flex gap-4">
				{{ title }}
				<IconMaterialSymbolsNorthEast class="size-6" />
			</span>
		</h3>

		<div
			class="font-sans text-sm font-medium tracking-wide text-white md:text-base"
		>
			{{ description }}
		</div>
	</div>
</template>
